import { Table } from "antd";
import React from "react";
import styled from "styled-components";
import { BorderRadius } from "../../constants/constant";

function CustomTable({
  data,
  columns,
  rowKey,
  onRow,
  pageSize = 10,
  ...props
}) {
  return (
    <StyledTable
      dataSource={data}
      columns={columns}
      rowKey={rowKey}
      onRow={onRow}
      scroll={{ x: true }}
      pagination={
        data?.length > pageSize ? { pageSize, showSizeChanger: false } : false // Hide pagination if condition is not met
      }
      {...props}
    />
  );
}

export default CustomTable;

const StyledTable = styled(Table)`
  border: 1px solid rgba(8, 10, 12, 0.175);
  border-radius: ${BorderRadius};
`;
